export default __webpack_public_path__ + "static/media/grid -view.74e17340.svg";